import { Box, Chip, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { TrainingMode } from "../../../store/tg-model-store";
import styles from "./TrainingModeSelector.module.scss";

interface TrainingModeSelectorProps {
	value: TrainingMode;
	onChange: (mode: TrainingMode) => void;
	disabledFullyAutomated?: boolean;
}

export const TrainingModeSelector: React.FC<TrainingModeSelectorProps> = ({
	value,
	onChange,
	disabledFullyAutomated,
}) => {
	const { t } = useTranslation("tg", { keyPrefix: "models.create.newExpertParameters.trainingModeSelector" });

	return (
		<Box className={styles.trainingModeSelector}>
			{/* FULLY AUTOMATED */}
			<Box
				className={`${styles.card} ${value === TrainingMode.FULLY_AUTOMATED ? styles.selected : ""}`}
				onClick={() => {
					if (disabledFullyAutomated) return;
					onChange(TrainingMode.FULLY_AUTOMATED);
				}}
				role="radio"
				aria-checked={value === TrainingMode.FULLY_AUTOMATED}
				aria-disabled={disabledFullyAutomated}
				data-disabled={disabledFullyAutomated ? "true" : undefined}
				style={disabledFullyAutomated ? { opacity: 0.5, pointerEvents: "none" } : undefined}
			>
				{/* Recommended badge */}
				<Chip label={t("autoPilot.recommended")} className={styles.badge} size="small" />

				<Box className={styles.header}>
					<Box className={styles.radio}>
						<span />
					</Box>

					<Box className={styles.text}>
						<Typography className={styles.title}>{t("autoPilot.title")}</Typography>

						<Typography className={styles.description}>{t("autoPilot.description")}</Typography>
					</Box>
				</Box>
			</Box>

			{/* EXPERT */}
			<Box
				className={`${styles.card} ${value === TrainingMode.EXPERT ? styles.selected : ""}`}
				onClick={() => onChange(TrainingMode.EXPERT)}
				role="radio"
				aria-checked={value === TrainingMode.EXPERT}
			>
				<Box className={styles.header}>
					<Box className={styles.radio}>
						<span />
					</Box>

					<Box className={styles.text}>
						<Typography className={styles.title}>{t("custom.title")}</Typography>

						<Typography className={styles.description}>{t("custom.description")}</Typography>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};
